import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { SolutionIntro } from './components/SolutionIntro';
import { HowItWorks } from './components/HowItWorks';
import { Gallery } from './components/Gallery';
import { UseCases } from './components/UseCases';
import { ShynessObjection } from './components/ShynessObjection';
import { WhatYouGet } from './components/WhatYouGet';
import { Purpose } from './components/Purpose';
import { Bonuses } from './components/Bonuses';
import { Reframe } from './components/Reframe';
import { Testimonials } from './components/Testimonials';
import { MissionTransition } from './components/MissionTransition';
import { FinalOffer } from './components/FinalOffer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalClose } from './components/FinalClose';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div lang="de" className="w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="3mk852v2dm5by">
      <SiteHeader data-id="element-1" data-mp="3rbrakqf99zft" />
      <main data-id="element-2" data-mp="3rdas0kcnegj6">
        <Hero data-id="element-3" data-mp="3rdkkqfp2v1sk" />
        <Problem data-id="element-4" data-mp="3rd191gq0t9mz" />
        <SolutionIntro data-id="element-5" data-mp="3relw6la09qat" />
        <HowItWorks data-id="element-6" data-mp="6hrlipoilfp" />
        <Gallery data-id="element-7" data-mp="4wx1t3d72hu" />
        <UseCases data-id="element-8" data-mp="5gg5d4r3wxg" />
        <ShynessObjection data-id="element-9" data-mp="82jf0klzq9v" />
        <WhatYouGet data-id="element-10" data-mp="2zld2jatxbhc2" />
        <Purpose data-id="element-11" data-mp="2zlv3gkrj6jqb" />
        <Bonuses data-id="element-12" data-mp="2zmemk4sx3e5x" />
        <Reframe data-id="element-13" data-mp="2zmwlj96ys6hj" />
        <Testimonials data-id="element-14" data-mp="2znfyebhrc4op" />
        <MissionTransition data-id="element-15" data-mp="33m5a7zn5de68" />
        <FinalOffer data-id="element-16" data-mp="33ngee0ki8nxv" />
        <Guarantee data-id="element-17" data-mp="33myl9ct52pu6" />
        <Faq data-id="element-18" data-mp="33ohzyyz5cstu" />
        <FinalClose data-id="element-19" data-mp="38m1elzzrb7mb" />
      </main>
      <Footer data-id="element-20" data-mp="38kqgafp2ys2l" />
    </div>;
}